import { useEffect, useRef } from "react";
import useIsVisible from "./useIsVisible";
import { applyVideoPlayback } from "../components/common/videoPlayback.helpers";

/**
 * Convenience hook for eager <video autoPlay loop> elements: returns a ref to
 * attach to the video, and plays/pauses it as it enters/leaves the viewport.
 *
 * WEB-2593: keeps mobile GPUs from exhausting their limited concurrent decode
 * streams when several looping videos share a page. Drop the element's
 * `autoPlay` attribute and attach this ref so playback is driven by visibility
 * alone.
 */
const usePauseOffscreenVideo = ({ rootMargin = "50px" } = {}) => {
  const ref = useRef(null);
  const isVisible = useIsVisible(ref, { rootMargin });

  useEffect(() => {
    applyVideoPlayback(ref.current, { isLoaded: true, isVisible });
  }, [isVisible]);

  return ref;
};

export default usePauseOffscreenVideo;
